import { SMV2Rubrics } from "src/app/components/order/fulle-product-v2/fulle-product-v2.interface";
import { SaleMethodSlim } from "src/app/components/order/fulle-selection-SM/fulle-selection-SM.interface";
import { PointOfSale } from "src/app/components/order/waiting-notes/waitingnotes.component";

interface TimeSlotPricePeriod {
    end: string;
    end_hour: number;
    end_minute: number;
    start: string;
    start_hour: number;
    start_minute: number;
}

interface TimeTablePricePeriod {
    day: number;
    id: number;
    id_point_of_sale: number;
    id_price_period: number;
    timeslots: TimeSlotPricePeriod[];
}

export interface PricePeriod {
    id: number;
    is_offer: number;
    name: string;
    name_webshop: string;
    timetables: TimeTablePricePeriod[]
}

export interface ProductParams {
    archive: number;
    id_sale_method: number;
    id_point_of_sale: number;
    with_ht: number;
    for_sale: number;
    handle_price_period: number;
    price_period_day: number | null;
    price_period_hour: string | null;
    language: string;
    rubric_id: string | number | null;
    limit_from: number | null;
    search: string | null;
    price_period_date: string | null;
}

interface ProductArg { }

interface Barcode { }
interface Categorie { }
interface DisplayLang {
    name: string;
    description: string;
}
interface Price {
    favorite: number;
    for_sale: number;
    id_price_period: null;
    id_sale_method: number;
    id_tax_grouping: number;
    price: number;
}
export interface Suggestion {
    ids: string;
    with_products_list: number;
}

export interface FulleProduct {
    account_id: number;
    allergens: number[];
    archive: number;
    barcode_variations: Barcode[];
    barcodes: Barcode[];
    benefits_titles: string[];
    blocked: number;
    calcul_type: number;
    categories: Categorie[];
    color: string;
    cost_price: null
    data_sheets: null
    date: string;
    description: string;
    disable_kitchen_level: number;
    display_lang: DisplayLang;
    enable_comment: number;
    expiration: number;
    external_id: string;
    fidelity_points: null;
    free_price: number;
    id: number;
    id_gomcpos: string;
    id_kitchen_level: number;
    image: string[];
    image_base64: string;
    image_link: string;
    kitchen_suffix: string;
    last_update: string;
    minimum_stock: number;
    name: string;
    optional_selection: number;
    order_name: string;
    points: null;
    points_of_sale: PointOfSale[];
    prestation_display: number;
    prestation_quantity: number;
    price: null;
    price_period: PricePeriod | null;
    prices: Price[];
    product_type: number;
    quantity: number;
    rubric: SMV2Rubrics;
    search_name: string;
    short_name: string;
    stock?: {count: number} | null; // a completer c'est peut-etre un FulleProducts
    suggestion_id: number;
    suggestions: number[];
    unit_measure: number;
    unit_measure_value: null;
    validity_from: string;
    validity_to: string;
    volume: null;
    weight: null;
}

interface Request {
    archive: string;
    for_sale: string;
    handle_price_period: string;
    id_point_of_sale: number;
    id_sale_method: string;
    language: string;
    light_request: number;
    limit_from: string;
    limit_to: string;
    order_by: string;
    price_period_date: string;
    price_period_day: string;
    price_period_hour: string;
    search: string;
    with_barcode: string;
    with_categories_details: number;
    with_ht: string;
}

export interface FulleProducts {
    args: ProductArg[];
    code: number;
    count: number;
    date: string;
    getByPricePeriod: PricePeriod[];
    list: FulleProduct[];
    next_limit_from: number;
    num_rows: number;
    products_to_display: number;
    queryPeriod: string;
    request: Request;
    sale_methods: SaleMethodSlim[];
}

export interface FulleParsedProds {
    count: number;
    displayDay: number | null;
    displayHour: string | null;
    next_limit_from: number | null;
    num_rows: number;
    products: FulleProduct[];
    products_to_display: number;
}

export interface FulleProductsSuggestions {
    id: number;
    id_product: number;
    id_suggestion: number;
    archive: number;
}

export interface ProductDisplayLang {
    name: string;
    description?: string;
}

export interface ProductPrice {
    price: number;
    id_price_period: number;
}

export interface ProductStock {
    count: number;
}

export interface ProductImage {
    [index: number]: string; // ton tableau image[0], image[1], image[2]
}

export interface Product {
    id: number;
    display_lang: ProductDisplayLang;
    description?: string;
    prices: ProductPrice[];
    stock?: ProductStock;
    image: string[];
}

export interface Rubric {
    id: string;
    name: string;
    products: Product[];
}

export interface Suggestions {
    archive: number;
    configuration_products: [];
    configuration_rubrics: number[];
    configuration_tags: [];
    description: string;
    id: number;
    is_kiosk_end: number;
    is_webshop_end: number;
    name: string;
    products: number[];
    products_exist_suggestions: FulleProduct[];
    products_exist_suggestions_list: SuggestionList[]
    products_to_suggest: number[];
}

export interface SuggestionList {
    products: FulleProduct[];
    rubric_id: number;
    rubric_name: string;
}
